import BackButton from '@sharedComponents/BackButton/BackButton';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';
import {ThemedView} from '../../theme'
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import { ThemedText } from '@app/theme';


type PageHeadersProps = {
  navigation : NativeStackNavigationProp<PrivateStackParamList>,
  pageName: keyof PrivateStackParamList
  label?:string
  showNeedHelp?:boolean
  triggerOpen?:boolean
  manualHandle?:()=>void
  setTriggerOpen?:()=>void
}


const PageHeaders = ({ navigation , pageName,label,showNeedHelp=true,manualHandle,triggerOpen=false,setTriggerOpen } : PageHeadersProps) => {
  return (
    <ThemedView
    flexDirection='row'
    justifyContent='space-between'
    bg={'bg-surface-primary'}
    paddingHorizontal='lg'
    borderBottomWidth={1}
    borderBottomColor='border-primary'
    height={60}
    alignItems='center'>
      <ThemedView flexDirection='row' alignItems='center' >
        <BackButton pageName={pageName} navigation={navigation} manualHandle={manualHandle}/>
        {label && <ThemedText color='text-primary' variant='b3m' ml='md'>{label}</ThemedText>}
      </ThemedView>
      {showNeedHelp && <NeedHelp triggerOpen={triggerOpen} setTriggerOpen={setTriggerOpen}/>}
    </ThemedView>
  );
};

export default PageHeaders;
